import ctaMan from "assets/images/psp/inlineCTA.jpg";
import HeaderBackgroundDesktop from "assets/images/psp/hero/golf-cart-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/golf-cart-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/golf-cart-header-tablet.webp";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import GolfCartStorageImage from "assets/images/psp/golf-cart-storage.webp";
import BatteryTenderImage from "assets/images/psp/battery-tender.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const faqs = [
	{
		question: "What size storage unit do I need for a golf cart?",
		answer: "A 10x10 unit comfortably fits most standard golf carts (approximately 8 feet long by 4 feet wide) with room for accessories. A 10x15 provides extra space for golf bags, maintenance equipment, and charging supplies—ideal for golf car storage with all your gear."
	},
	{
		question: "How should I prepare my golf cart for storage?",
		answer: "Clean the cart thoroughly, fully charge the battery (then disconnect it or use a trickle charger), inflate tires to recommended pressure, and cover the cart to prevent dust. For winter golf cart storage exceeding 30 days, consider removing the battery entirely and storing it in a climate-controlled space."
	},
	{
		question: "Do golf cart batteries need special care in storage?",
		answer: "Yes, batteries discharge slowly over time and can suffer permanent damage if fully depleted. Use a trickle charger or smart charger if your storage facility has electrical outlets, or remove the battery and charge it monthly at home to maintain its health."
	},
	{
		question: "Can I store a gas-powered golf cart?",
		answer: "Absolutely. Most facilities allow gas-powered carts with proper preparation. Add fuel stabilizer to the tank, run the engine briefly to circulate it, and follow all facility regulations regarding fuel storage for safety compliance."
	},
	{
		question:
			"Is covered storage enough, or should I choose indoor storage?",
		answer: "Covered golf cart storage works well for short-term needs or mild climates, protecting against rain and sun. For winter storage, extreme climates, or premium carts with sensitive electronics, fully enclosed or climate-controlled units provide better protection for your investment."
	}
];

const relatedContentCards = [
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/storing-golf-cart-storage-unit/",
		date: "April 3, 2025",
		image: GolfCartStorageImage,
		content:
			"How to Store a Golf Cart: Storing a Golf Cart in a Storage Unit and Other Golf Cart Storage Ideas"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/cost-of-car-storage/",
		date: "September 8, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/09/outdoorparking-jpg.webp",
		content:
			"How Much Does Vehicle Storage Cost? Comprehensive Guide with Price Comparisons"
	},
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/what-is-battery-tender-vehicle-storage/",
		date: "August 4, 2025",
		image: BatteryTenderImage,
		content:
			"What is a Battery Tender? A Complete Guide for Vehicle Storage"
	}
];

const pspLinksContent = {
	title: "More Ways to Store",
	image: illustrationSearch,
	storageTypes: storageCategories.golfCart
};

const reviewsContent = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "It was easy to find a location I needed, and once I sent my request, the gal called me that evening and was super friendly. I've been stressed about finding a place to store my car between visits, and this experience made it so easy, and now I can relax!",
			author: "Marcia Pierce-rasmussen",
			title: "Super easy and relaxing experience!	",
			imageSrc: AnnAlarcon
		},
		{
			body: "I needed a storage space for my car that had to be a drive-up and climate-controlled, and 10x20. Efficient searching and found exactly what I was looking for, and held it for me.",
			author: "Blaine Dyson",
			title: "Very helpful Very helpful",
			imageSrc: GeorgeRansom
		},
		{
			body: "This was a great place to look for local storage for my vehicle, which was a sports car for the summer. They were able to find me the closest and cheapest storage, which is not easy. They also provide terms and costs, so it was no surprise when I signed up.",
			author: "David W. Young",
			title: "Excellent Place to Look for Vehicle Storage",
			imageSrc: SMurphy
		}
	]
};

const golfCartHerodescription = `Protect your golf cart and free up valuable space with convenient outdoor and covered golf cart storage options near you. Whether you need winter golf cart protection during off-season months, want to store golf carts between rounds, or lack covered space at home, there's a storage facility for you.`;

const golfStorageContent = `
**Indoor Golf Cart Storage**

- Fully enclosed units  
- Offers protection from weather extremes, UV damage, and temperature fluctuations  
- Best option for winter golf cart storage  
- Many locations provide electrical outlets for battery maintenance  

**Outdoor Covered Golf Cart Storage**

- Carport-style covered spaces  
- Budget friendly  
- Rain, snow, and direct sunlight protection  
- Best for short-term storage  

**Drive-Up Storage Units**

- Individual garage-style spaces  
- Ground-level access for easy cart retrieval  
- Combines the convenience of covered golf cart storage with added security  
`;

export const PSPGolfCartContent = {
	type: "Golf Cart",
	sections: [
		{
			title: "Golf Cart hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top Golf Cart Storage",
						description: golfCartHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find Golf Cart Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "Golf Cart Storage Hero Image"
					}
				}
			]
		},
		{
			title: "Golf Cart Storage Content",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "Covered Storage for Golf Carts & More",
						background: "light-blue",
						content: [
							{
								id: "1",
								value: "Golf cart storage solutions cater to both recreational and utility cart owners who need protection from the elements and secure storage between uses. From seasonal golfers to community residents with electric carts, storage facilities offer the covered, climate-stable environment that extends your cart's lifespan and [maintains battery health.](https://www.storage.com/blog/what-is-battery-tender-vehicle-storage/)"
							},
							{
								id: "2",
								value: golfStorageContent
							},
							{
								id: "3",
								value: "Storage for golf carts also accommodates accessories and equipment—golf bags, maintenance supplies, charging equipment, and seasonal accessories all stay organized and protected alongside your cart. Many facilities offer flexible rental terms, allowing you to store seasonally during the winter months or year-round if you require permanent space."
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "Golf Cart Storage Amenities",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "The Most Popular Amenities for Golf Cart, UTV, and Golf Car Storage",
						description:
							"Sometimes, a storage unit is more than storage for your golf cart. Here are some amenities that will level up your golf cart's home away from home.",
						background: "white",
						storages: [
							{
								title: "Electrical Outlets",
								bestFor: [
									"Winter golf cart storage",
									"Long term storage"
								]
							},
							{
								title: "Ground-Floor Access",
								bestFor: [
									"All golf cart storage",
									"Easy access"
								]
							},
							{
								title: "Climate Control",
								bestFor: [
									"Premium carts",
									"Year-round storage",
									"Inclement weather"
								]
							},
							{
								title: "Covered Parking",
								bestFor: [
									"Seasonal storage",
									"Budget-conscious owners"
								]
							},
							{
								title: "Security Gates & Cameras",
								bestFor: [
									"All storage scenarios",
									"Enhanced security",
									"Peace of mind"
								]
							},
							{
								title: "Wide Drive Aisles",
								bestFor: [
									"Large carts",
									"Owners with limited experience"
								]
							},
							{
								title: "24-Hour Access",
								bestFor: [
									"Owner flexibility",
									"Seasonal golfers"
								]
							}
						]
					}
				}
			]
		},
		{
			title: "Golf Cart Storage Costs",
			noPadding: true,
			modules: [
				{
					type: "size-chart",
					props: {
						title: "How Much Does Golf Cart Storage Cost?",
						description:
							"Golf cart storage costs depend on location, unit type, and amenities. Based on current pricing data from Storage.com facilities, here are some ***monthly*** rates you can expect to see:",
						background: "light-blue",
						storages: [
							{
								title: "Outdoor Covered",
								numerics: ["$40-$100"],
								bestFor: [
									"Seasonal protection",
									"Budget storage"
								]
							},
							{
								title: "Small Indoor Units (10x10)",
								numerics: ["$75-$150"],
								bestFor: [
									"Single golf cart",
									"Minimal accessories"
								]
							},
							{
								title: "Medium Indoor Units (10x15)",
								numerics: ["$100-$200"],
								bestFor: [
									"Any size golf cart",
									"Additional supplies"
								]
							},
							{
								title: "Climate-Controlled",
								numerics: ["$125-$250"],
								bestFor: ["Premium carts", "Year-round storage"]
							}
						]
					}
				}
			]
		},
		{
			title: "Golf Cart Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "Golf Cart",
						background: "white",
						subheading: "Make a free reservation in minutes!",
						searchPlaceholder: "Search by city, state, or zip...",
						searchButtonText: "Find Storage",
						image: ctaMan,
						imageAltText: "Find golf cart storage"
					}
				}
			]
		},
		{
			title: "Golf Cart Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviewsContent
				}
			]
		},
		{
			title: "Golf Cart faqs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "Golf Cart Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "Golf Cart Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About Golf Cart Storage",
						unitCards: relatedContentCards,
						background: "light-blue"
					}
				}
			]
		},
		{
			title: "Links to Other PSPs",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						storageGridContent: pspLinksContent,
						background: "white"
					}
				}
			]
		},
		{
			title: "Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						storageType: "golf-cart",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPGolfCartContent;
